// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.memory-detail-page {
  min-height: 100vh;
  background: #f4f6f8;
  color: #252a31;
}

.memory-detail-shell {
  width: min(980px, calc(100% - 32px));
  margin: 0 auto;
  padding: 28px 0 52px;
}

.memory-detail-back {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  margin-bottom: 18px;
  color: #1f5a99;
  font-weight: 700;
  text-decoration: none;
}

.memory-detail-back:hover {
  text-decoration: underline;
}

.memory-detail {
  display: grid;
  gap: 24px;
  padding: 24px;
  border: 0;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
}

.memory-detail-header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e4e7eb;
  padding-bottom: 16px;
}

.memory-detail-header span {
  color: #1f5a99;
  font-weight: 800;
  text-transform: uppercase;
}

.memory-detail-header p {
  margin: 0;
  color: #68717d;
}

.memory-detail-image-button {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: #edf0f3;
  cursor: zoom-in;
  overflow: hidden;
}

.memory-detail-image-button img {
  display: block;
  width: 100%;
  max-height: 72vh;
  object-fit: contain;
  background: #f0f2f5;
}

.memory-detail-body {
  display: grid;
  gap: 16px;
}

.memory-detail-body h1 {
  margin: 0;
  color: #1f2933;
  font-size: 30px;
  overflow-wrap: anywhere;
  line-height: 1.15;
}

.memory-detail-body p,
.memory-detail-body blockquote {
  margin: 0;
  color: #323942;
  font-size: 19px;
  overflow-wrap: anywhere;
  line-height: 1.55;
  white-space: pre-wrap;
}

.memory-detail-admin {
  display: inline-block;
  margin: 0 0 18px 20px;
  font-size: 14px;
}

.memory-detail-body blockquote {
  border-left: 5px solid #1f5a99;
  padding-left: 18px;
  color: #174f88;
  font-style: italic;
}

.memory-detail-footer {
  border-top: 1px solid #e4e7eb;
  padding-top: 14px;
  color: #6c737d;
  font-size: 14px;
}

@media (max-width: 640px) {
  .memory-detail-shell {
    width: min(100% - 20px, 980px);
    padding-top: 14px;
  }

  .memory-detail {
    padding: 16px;
  }
}
.memory-hosted-player {
  display: block;
  width: 100%;
  max-height: 75vh;
  aspect-ratio: 16 / 9;
  background: #111;
}
`, "",{"version":3,"sources":["webpack://./src/MemoryDetailPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB","sourcesContent":[".memory-detail-page {\n  min-height: 100vh;\n  background: #f4f6f8;\n  color: #252a31;\n}\n\n.memory-detail-shell {\n  width: min(980px, calc(100% - 32px));\n  margin: 0 auto;\n  padding: 28px 0 52px;\n}\n\n.memory-detail-back {\n  display: inline-flex;\n  align-items: center;\n  min-height: 40px;\n  margin-bottom: 18px;\n  color: #1f5a99;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.memory-detail-back:hover {\n  text-decoration: underline;\n}\n\n.memory-detail {\n  display: grid;\n  gap: 24px;\n  padding: 24px;\n  border: 0;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: none;\n}\n\n.memory-detail-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  border-bottom: 1px solid #e4e7eb;\n  padding-bottom: 16px;\n}\n\n.memory-detail-header span {\n  color: #1f5a99;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.memory-detail-header p {\n  margin: 0;\n  color: #68717d;\n}\n\n.memory-detail-image-button {\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: #edf0f3;\n  cursor: zoom-in;\n  overflow: hidden;\n}\n\n.memory-detail-image-button img {\n  display: block;\n  width: 100%;\n  max-height: 72vh;\n  object-fit: contain;\n  background: #f0f2f5;\n}\n\n.memory-detail-body {\n  display: grid;\n  gap: 16px;\n}\n\n.memory-detail-body h1 {\n  margin: 0;\n  color: #1f2933;\n  font-size: 30px;\n  overflow-wrap: anywhere;\n  line-height: 1.15;\n}\n\n.memory-detail-body p,\n.memory-detail-body blockquote {\n  margin: 0;\n  color: #323942;\n  font-size: 19px;\n  overflow-wrap: anywhere;\n  line-height: 1.55;\n  white-space: pre-wrap;\n}\n\n.memory-detail-admin {\n  display: inline-block;\n  margin: 0 0 18px 20px;\n  font-size: 14px;\n}\n\n.memory-detail-body blockquote {\n  border-left: 5px solid #1f5a99;\n  padding-left: 18px;\n  color: #174f88;\n  font-style: italic;\n}\n\n.memory-detail-footer {\n  border-top: 1px solid #e4e7eb;\n  padding-top: 14px;\n  color: #6c737d;\n  font-size: 14px;\n}\n\n@media (max-width: 640px) {\n  .memory-detail-shell {\n    width: min(100% - 20px, 980px);\n    padding-top: 14px;\n  }\n\n  .memory-detail {\n    padding: 16px;\n  }\n}\n.memory-hosted-player {\n  display: block;\n  width: 100%;\n  max-height: 75vh;\n  aspect-ratio: 16 / 9;\n  background: #111;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
